const binding = { modules: {}, dataActions: {} };

    (binding.modules['commerce-assistant'] = {
        c: () => require('partner/modules/commerce-assistant/commerce-assistant.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'commerce-assistant',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/commerce-assistant'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|commerce-assistant|commerce-assistant'] = {
                c: () => require('partner/modules/commerce-assistant/commerce-assistant.view.tsx'),
                cn: '__local__-__local__-commerce-assistant'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };